<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12">
                <label for="imagen">Imagen cabecera email:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X287 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_cabecera_url">
                    <img :src="manager.imagen_cabecera_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_cabecera')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="287"
                        :width="2182"
                        :acceptedFiles="'image/jpeg'"
                        @success="imagenSubida('imagen_cabecera', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen patrocinadores email:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X319 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_patrocinadores_url">
                    <img :src="manager.imagen_patrocinadores_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_patrocinadores')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="319"
                        :width="2182"
                        :acceptedFiles="'image/jpeg'"
                        @success="imagenSubida('imagen_patrocinadores', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen publicidad email:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X667 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_publicidad_url">
                    <img :src="manager.imagen_publicidad_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_publicidad')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="667"
                        :width="2182"
                        :acceptedFiles="'image/jpeg'"
                        @success="imagenSubida('imagen_publicidad', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                managerLocal: this.manager
            }
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_patrocinadores':
                        this.managerLocal.imagen_patrocinadores = null;
                        this.managerLocal.imagen_patrocinadores_url = null;
                        break;
                    case 'imagen_cabecera':
                        this.managerLocal.imagen_cabecera = null;
                        this.managerLocal.imagen_cabecera_url = null;
                        break;
                    case 'imagen_publicidad':
                        this.managerLocal.imagen_publicidad = null;
                        this.managerLocal.imagen_publicidad_url = null;
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_patrocinadores':
                        this.managerLocal.imagen_patrocinadores = response;
                        break;
                    case 'imagen_cabecera':
                        this.managerLocal.imagen_cabecera = response;
                        break;
                    case 'imagen_publicidad':
                        this.managerLocal.imagen_publicidad = response;
                        break;
                }
            }
        },
        components: {
            Dropzone
        }
    }
</script>
